<template>
  <section>
    <div v-for="item in items" :key="item.tableauMenuFolderId">
      <div class="folder-container" @click="selectedFolder(item.tableauMenuFolderId)">
        <span class="title-box" :title="item.title">
          <b-icon-folder/>
          {{ item.title }}
        </span>
        <span class="icon-button ml-1 border border-primary rounded px-1"
              @click="deleteFolder(item.tableauMenuFolderId)">
          <b-icon-trash variant="primary"/>
        </span>
        <span class="icon-button ml-1 border  border-primary rounded px-1" @click="editFolder(item)">
          <b-icon-pencil variant="primary"/>
        </span>

      </div>
      <tree-node class="ml-3" v-if="item.children && item.children.length" :items="item.children"
                 @editFolder="editFolder" @deleteFolder="deleteFolder" @selectedFolder="selectedFolder"/>
    </div>
  </section>
</template>

<script>
export default {
  name: "TreeNode",
  props: {items: Array},
  methods: {
    editFolder(item) {
      this.$emit('editFolder', item);
    },
    deleteFolder(id) {
      this.$emit('deleteFolder', id);
    },
    selectedFolder(id) {
      this.$emit('selectedFolder', id);
    }
  }
}
</script>

<style scoped>
.icon-button {
  visibility: hidden;
  display: inline-block;
  cursor: pointer;
  float: right;
  vertical-align: bottom;
  z-index: 10;
}

.folder-container {
  cursor: pointer;
}

.folder-container:hover .icon-button {
  visibility: visible;
}

.title-box {
  display: inline-block;
  width: calc(100% - 60px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>